import React, { useState, useEffect } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { getAllEditDistancesSync } from "./levenstein";
import { routesToMatch } from "./../Router.component";
import SVG404 from "./../../assets/svg/icons/404.svg";

const _getPath = (url) => {
  const idx = url.lastIndexOf("/");
  return url ? url.substring(idx >= 0 ? idx + 1 : 0) : url;
};

const DISTANCE_UPPER_BOUND = 10;

const Error404 = () => {
  const match = useRouteMatch();
  const [suggestion, setSuggestion] = useState("");

  useEffect(() => {
    const candidates = getAllEditDistancesSync(
      _getPath(match.url),
      routesToMatch,
      DISTANCE_UPPER_BOUND
    );
    if (candidates.length > 0) {
      const winner = candidates.reduce((prev, curr) =>
        prev.distance < curr.distance ? prev : curr
      );
      setSuggestion(winner.word);
    }
  }, [match]);

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center w-auto pt-5"
      style={{ minHeight: "70vh" }}
    >
      <img
        src={SVG404}
        alt="404 symbol"
        className="h-auto mb-5"
        style={{ maxWidth: "30%" }}
      />
      {suggestion && (
        <h1 className="font-open-sans">
          Hmm...
          <span className="font-open-sans">
            {" "}
            Did you mean{" "}
            <Link to={`/${suggestion}`}>
              <i>{`/${suggestion}`}</i>
            </Link>
            ?
          </span>
        </h1>
      )}
      {!suggestion && (
        <h1 className="font-open-sans">
          The requested url does not exist.
          <br />
          Here's{" "}
          <Link to={"/"}>
            {" "}
            <i>Home</i>
          </Link>
        </h1>
      )}
    </div>
  );
};

export default Error404;
